import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageBlocks from "@/components/site/PageBlocks";
import PageHeader from "@/components/site/PageHeader";

const CATEGORIES = [
  "Réformes de l'enseignement", "Mobilisations", "Vie scolaire", "Bien-être",
  "Numérique", "Harcèlement", "Orientation", "Participation des élèves",
];

const COLORS = {
  "Réformes de l'enseignement": "bg-cef-blue text-white",
  "Mobilisations": "bg-cef-pink text-white",
  "Vie scolaire": "bg-cef-yellow",
  "Bien-être": "bg-cef-green",
  "Numérique": "bg-black text-white",
  "Harcèlement": "bg-cef-pink text-white",
  "Orientation": "bg-cef-yellow",
  "Participation des élèves": "bg-cef-blue text-white",
};

export default function News() {
  const [items, setItems] = React.useState([]);
  const [cat, setCat] = React.useState(null);

  React.useEffect(() => {
    api.get("/articles", { params: cat ? { category: cat } : {} }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <PageHeader slug="actualites" fallbackTitle="Actualités" fallbackSubtitle="Le fil d'infos écrit par des élèves, pour des élèves. Pas de jargon, du concret." />

      <PageBlocks slug="actualites" className="mt-6" />

      <div className="mt-6 flex flex-wrap gap-2" data-testid="news-categories">
        <button onClick={() => setCat(null)} className={`chip ${!cat ? "bg-black text-white" : "bg-white"}`} data-testid="cat-all">Tout</button>
        {CATEGORIES.map((c) => (
          <button key={c} onClick={() => setCat(c)} className={`chip ${cat === c ? COLORS[c] : "bg-white"}`} data-testid={`cat-${c}`}>{c}</button>
        ))}
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="news-grid">
        {items.map((a) => (
          <Link key={a.id} to={`/actualites/${a.slug}`} className="neo-card overflow-hidden block group" data-testid={`article-card-${a.slug}`}>
            {a.image_url && <div className="h-44 overflow-hidden border-b-2 border-black"><img src={a.image_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition" /></div>}
            <div className="p-5">
              <span className={`chip ${COLORS[a.category] || "bg-white"}`}>{a.category}</span>
              <h3 className="mt-3 font-display font-black text-lg tracking-tight leading-snug">{a.title}</h3>
              <p className="mt-2 text-sm text-neutral-600 line-clamp-3">{a.excerpt}</p>
            </div>
          </Link>
        ))}
        {items.length === 0 && <div className="text-neutral-500">Aucun article pour cette catégorie.</div>}
      </div>
    </div>
  );
}
